import playSpotifyWithoutSymptons from '@/assets/covid/playlists/play-spotify.svg';
import playSpotifyWithSymptons from '@/assets/covid/playlists/play-spotify2.svg';
interface ExamResultInterface {
  title: string;
  subTitleInfo: string;
  guidelinesHtml: string;
  playlistTitle: string;
  playlistText: string;
  url: string;
  subtitle: string;
  info: string;
  imageResult: string;
  playlistUrl: string;
  class: string;
  urlVideo: string;
  titleVideoResult: string;
  ImgplayWithSymptons: typeof playSpotifyWithSymptons;
  ImgplaySpotifyWithoutSymptons: typeof playSpotifyWithoutSymptons;
}

const PositiveWithSymptons: ExamResultInterface = {
  title: 'Positivo',
  subtitle: 'e com sintomas',
  subTitleInfo: 'Inicie agora mesmo seu isolamento domiciliar.',
  guidelinesHtml:
    '<p>Seu resultado foi positivo para coronavírus e você informou estar com sintomas.</p><p>Com um resultado positivo para o antígeno da COVID-19, o Ministério da Saúde recomenda isolamento em domicílio por até 10 dias, até que os sintomas desapareçam por completo e/ou você repita o teste, com resultado negativo.</p><p>Evite sair de casa e ter contato com outras pessoas. O isolamento evita a contaminação de outras pessoas e a disseminação do coronavírus.</p><p>Avise as pessoas que tiveram contato com você nas últimas 72h para também se testarem e se isolarem caso apresentem resultado positivo.</p><p>Se estiver sentido sintomas mais graves, como falta de ar, pressão no peito ou muito cansaço, busque assistência médica.</p>',
  playlistTitle: 'DICA DO DIA',
  playlistText: 'É hora de repousar em casa e ver um filminho',
  url: 'bit.ly/vcEmQuarentena',
  info: 'Você deve iniciar seu isolamento domiciliar',
  imageResult: 'urlPositiveWithSymptomsImage',
  ImgplayWithSymptons: '',
  ImgplaySpotifyWithoutSymptons: '',
  playlistUrl: 'https://bit.ly/vcEmQuarentena',
  class: 'positive-with-symptoms',
  urlVideo: 'https://player.vimeo.com/video/802707105?h=27df0a762a',
  titleVideoResult: 'Saiba o que você deve fazer agora:',
};

const PositiveWithoutSymptons: ExamResultInterface = {
  title: 'Positivo',
  subtitle: 'e sem sintomas',
  subTitleInfo: 'Inicie agora mesmo seu isolamento domiciliar.',
  guidelinesHtml:
    '<p>Seu resultado foi positivo para coronavírus e você informou não estar com sintomas.</p><p></p><p>Com um resultado positivo para o antígeno da COVID-19, o Ministério da Saúde recomenda isolamento em domicílio por até 10 dias. Mesmo sem sintomas, você pode transmitir o vírus a outras pessoas.</p><p></p><p>Evite sair de casa e ter contato com outras pessoas. Avise as pessoas que tiveram contato com você nas últimas 72h para também se testarem e se isolarem caso apresentem resultado positivo.</p><p></p><p>Após 5 dias de isolamento, você pode repetir o teste. Caso seu resultado seja negativo, você já poderá sair do isolamento. Caso decida não repetir o teste, espere a conclusão dos 10 dias de isolamento.</p>',
  playlistTitle: 'DICA DO DIA',
  playlistText: 'É hora de repousar em casa e ver um filminho',
  url: 'bit.ly/vcEmQuarentena',
  info: 'Você deve iniciar seu isolamento domiciliar',
  imageResult: 'urlPositiveWithoutSymptomsImage',
  ImgplayWithSymptons: '',
  ImgplaySpotifyWithoutSymptons: '',
  playlistUrl: 'https://bit.ly/vcEmQuarentena',
  class: 'positive-without-symptoms',
  urlVideo: 'https://player.vimeo.com/video/802707152?h=abd548bbcc',
  titleVideoResult: 'Saiba o que você deve fazer agora:',
};

const NegativeWithSymptons: ExamResultInterface = {
  title: 'Negativo',
  subtitle: 'e com sintomas',
  subTitleInfo: 'Mantenha os cuidados preventivos, considere repetir o teste.',
  guidelinesHtml:
    '<p>Seu resultado foi negativo para coronavírus , mas você informou estar com sintomas.</p><p>Isso pode ser indicativo de infecção por coronavírus, mas ainda não detectável pelo teste, ou outro problema de saúde.</p><p>Por precaução, você pode repetir seu autoteste dentro de 24h para confirmar o resultado ou buscar uma farmácia para fazer o teste confirmatório com um profissional da saúde.</p><p>Enquanto estiver com sintomas, evite sair de casa e ter contato com outras pessoas. Mantenha os cuidados preventivos, como uso de máscara e higiene das mãos.</p><p>Se estiver sentido sintomas mais graves, como falta de ar, pressão no peito ou muito cansaço, busque assistência médica.</p>',
  playlistTitle: 'TRACK DO DIA',
  playlistText: 'Você está livre para aproveitar o seu dia ao som de',
  url: 'spoti.fi/3FBx9vf',
  info: 'É preciso ter atenção!',
  imageResult: 'urlNegativeWithSymptomsImage',
  ImgplayWithSymptons: playSpotifyWithSymptons,
  ImgplaySpotifyWithoutSymptons: '',
  playlistUrl:
    'https://open.spotify.com/embed/track/2MDXtCngtKODfZaWieV0JF?utm_source=generator',
  class: 'negative-with-symptoms',
  urlVideo: 'https://player.vimeo.com/video/802707004?h=38020d8a31',
  titleVideoResult: 'Quais cuidados você deve manter para evitar o vírus:',
};

const NegativeWithoutSymptons: ExamResultInterface = {
  title: 'Negativo',
  subtitle: 'e sem sintomas',
  subTitleInfo:
    'Mantenha os cuidados preventivos, não há necessidade de isolamento.',
  guidelinesHtml:
    '<p>Seu resultado foi negativo para coronavírus, e você informou não estar com sintomas, portanto não há necessidade de isolamento.</p><p>Esse resultado não elimina o risco de você se contaminar no futuro, por isso mantenha as medidas de prevenção, como o uso de máscara, higiene das mãos e distanciamento social.</p><p>Se você teve contato com alguém que testou positivo para COVID-19, fique atento à manifestação de sintomas como febre, dor no corpo e dificuldade para respirar, e realize um novo teste dentro de 24h.</p><p>Se você precisa de um exame com laudo para viagens, trabalho ou participação em eventos, agende um atendimento na farmácia para fazer o teste confirmatório com o profissional da saúde.</p>',
  playlistTitle: 'TRACK DO DIA',
  playlistText: 'Você está livre para aproveitar o seu dia ao som de',
  url: 'spoti.fi/3yM0KRB',
  info: 'Você está livre para circular!',
  imageResult: 'urlNegativeWithoutSymptomsImage',
  ImgplayWithSymptons: '',
  ImgplaySpotifyWithoutSymptons: playSpotifyWithoutSymptons,
  playlistUrl:
    'https://open.spotify.com/embed/track/6XOsXDAtgNGOPzyalU4zcT?utm_source=generator',
  class: 'negative-without-symptoms',
  urlVideo: 'https://player.vimeo.com/video/802707043?h=42adaad7a6',
  titleVideoResult: 'Quais cuidados você deve manter para evitar o vírus:',
};

export {
  ExamResultInterface,
  PositiveWithSymptons,
  PositiveWithoutSymptons,
  NegativeWithSymptons,
  NegativeWithoutSymptons,
};
